// extracted by mini-css-extract-plugin
module.exports = {"outerClass":"Cashflow_outerClass__3EOd0","header":"Cashflow_header__3obvn","headTag":"Cashflow_headTag__2yqGP","amtTag":"Cashflow_amtTag__3VtlS","center":"Cashflow_center__t9CRA"};